import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { PageLoading } from 'components/loading'
import { useAcessoHasVinculacaoEquipeNasfQuery } from 'graphql/hooks.generated'
import { Redirect, useRouteMatch } from 'react-router'
import { isCboGerente } from 'types/NivelCbo'

import { LCC_TABS_ROUTE } from '../CuidadosCompartilhadosRootView'
import { ListaCuidadoCompartilhadoGerenteView } from './ListaCuidadoCompartilhadoGerenteView'

export const ListaCuidadoCompartilhadoRootView = () => {
  const match = useRouteMatch()

  const {
    data: { acessoHasVinculacaoEquipeNasf },
    loading,
  } = useAcessoHasVinculacaoEquipeNasfQuery()

  const { acesso } = useAcessoLotacaoOrEstagio()
  const isGerenteUbs = isCboGerente(acesso.cbo.cbo2002)

  const defaultTabOpen = acessoHasVinculacaoEquipeNasf ? LCC_TABS_ROUTE['SOLICITANTE'] : LCC_TABS_ROUTE['EXECUTANTE']

  if (loading) return <PageLoading message='Carregando...' />

  if (!isGerenteUbs) {
    return <Redirect to={`${match.url}/${defaultTabOpen}`} />
  }

  return <ListaCuidadoCompartilhadoGerenteView />
}
